export const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;

export const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;

export const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;

export const databaseURL = process.env.REACT_APP_FIREBASE_URL;

export const pairistVersion = process.env.REACT_APP_PAIRIST_VERSION || '2.x.x-dev';

export const allowedEmailDomains = process.env.REACT_APP_ALLOWED_EMAIL_DOMAINS;
